"use client"

import { useEffect, useState } from "react"

import { CalculatedProductPrice } from "@lib/util/get-product-price"
import { sendGoogleAnalyticsEvent } from "@modules/common/utils/analytics"

import InstallmentContainer from "./InstallmentContainer"
import StepWrapper from "../common/StepWrapper"

interface PaymentOptionsPickerProps {
  calculatedPrices: CalculatedProductPrice | null
  onInstallmentSelected: (installments?: number) => void
  onContinue: () => void
  onBack: () => void
  preSelectedInstallment?: number
}

const PAYMENT_OPTIONS_TEXTS = {
  title: "¿Cómo te gustaría pagar por tu compra?",
  subtitle: "Comenzarás a pagar únicamente al recibir tu compra.",
  footer: "*Precios no incluyen costo de envío.",
}

const PaymentOptionsPicker = ({
  calculatedPrices,
  onInstallmentSelected,
  onContinue,
  onBack,
  preSelectedInstallment,
}: PaymentOptionsPickerProps) => {
  const [selectedInstallment, setSelectedInstallment] = useState<number>()

  const handleInstallmentSelection = (installments?: number) => {
    setSelectedInstallment(installments)
    onInstallmentSelected(installments)
  }
  const handleClearSelection = () => {
    setSelectedInstallment(undefined)
    onInstallmentSelected(undefined)
  }

  const handleSubmit = () => {
    sendGoogleAnalyticsEvent("INSTALLMENT_SELECTED", {
      installmentSelected: selectedInstallment,
    })
    onContinue()
  }

  useEffect(() => {
    if (preSelectedInstallment) {
      setSelectedInstallment(preSelectedInstallment)
    }
  }, [preSelectedInstallment])

  return (
    <StepWrapper
      title={PAYMENT_OPTIONS_TEXTS.title}
      subtitle={PAYMENT_OPTIONS_TEXTS.subtitle}
      progressPercentage={0}
      onSubmit={handleSubmit}
      submitDisabled={!selectedInstallment}
      showBackButton={!!onBack}
      onBack={onBack}
      isLoading={!calculatedPrices}
    >
      <div className="flex flex-row justify-between">
        <p className="text-md font-bold">Plan de pagos:</p>
        <button
          onClick={handleClearSelection}
          className={`cursor-pointer hover:underline ${selectedInstallment ? "text-nelo-blue" : "text-gray-500"}`}
          type="button"
          disabled={!selectedInstallment}
        >
          Cambiar
        </button>
      </div>
      <div className="mb-4">
        <InstallmentContainer
          onInstallmentSelected={handleInstallmentSelection}
          calculatedPrices={calculatedPrices}
          preSelectedInstallment={preSelectedInstallment}
        />
      </div>
    </StepWrapper>
  )
}

export default PaymentOptionsPicker
